"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SpeechBubblesIcon = function SpeechBubblesIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11 4H3V3h8zM3 5v1h6V5zm9-5H2a2.002 2.002 0 0 0-2 2v5a2.002 2.002 0 0 0 2 2h1v3.5l3-2.25V9l-2 1.5V8H2a1.001 1.001 0 0 1-1-1V2a1.001 1.001 0 0 1 1-1h10a1.001 1.001 0 0 1 1 1v4h1V2a2.002 2.002 0 0 0-2-2zM9 9v1h5V9zm3 2H9v1h3zm2.5-4a1.483 1.483 0 0 1 .5.092A1.498 1.498 0 0 1 16 8.5v4a1.502 1.502 0 0 1-1.5 1.5H14v1.204a.657.657 0 0 1-.348.581.665.665 0 0 1-.311.077.658.658 0 0 1-.363-.11L10.348 14H8.5A1.502 1.502 0 0 1 7 12.5v-4A1.502 1.502 0 0 1 8.5 7zm0 1h-6a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.151L13 14.566V13h1.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 6h10v1H5zm0 3v1h7V9zm1 7.519V13H3a1.001 1.001 0 0 1-1-1V4a1.001 1.001 0 0 1 1-1h14a1.001 1.001 0 0 1 1 1v6h1V4a2.002 2.002 0 0 0-2-2H3a2.002 2.002 0 0 0-2 2v8a2.002 2.002 0 0 0 2 2h2v4.481l4-2.908v-1.237zM13 15h7v-1h-7zm0 2h5v-1h-5zm10-4v5a2.002 2.002 0 0 1-2 2h-1v3.5L15.334 20H12a2.002 2.002 0 0 1-2-2v-5a2.002 2.002 0 0 1 2-2h9a2.002 2.002 0 0 1 2 2zm-1 0a1.001 1.001 0 0 0-1-1h-9a1.001 1.001 0 0 0-1 1v5a1.001 1.001 0 0 0 1 1h3.667L19 21.5V19h2a1.001 1.001 0 0 0 1-1z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 10h12v1H7zm0 4h8v-1H7zm5.349 4L7 21.565V18H4a1.001 1.001 0 0 1-1-1V7a1.001 1.001 0 0 1 1-1h18a1.001 1.001 0 0 1 1 1v7h1V7a2.002 2.002 0 0 0-2-2H4a2.002 2.002 0 0 0-2 2v10a2.002 2.002 0 0 0 2 2h2v4.435L12.651 19H14v-1zM30 17v6a2.002 2.002 0 0 1-2 2h-1v3.99L21.585 25H17a2.002 2.002 0 0 1-2-2v-6a2.002 2.002 0 0 1 2-2h11a2.002 2.002 0 0 1 2 2zm-1 0a1.001 1.001 0 0 0-1-1H17a1.001 1.001 0 0 0-1 1v6a1.001 1.001 0 0 0 1 1h4.915L26 27.01V24h2a1.001 1.001 0 0 0 1-1zm-10 1v1h7v-1zm0 4h5v-1h-5z"
  }));
};

var _default = SpeechBubblesIcon;
exports["default"] = _default;